import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { routeNaming, AppLink } from '../../../routes';
import { CartStore } from '../../../stores/CartStore';
import iconCart from './icon-cart.svg';
import styles from './CartButton.css';
import { CartPopUp } from '../cart-pop-up/CartPopUp';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const CartButton = props => (
  <div className={styles.containerWithPopUp}>
    <div className={[styles.container, props.className].join(' ')}>
      <AppLink
        className={styles.link}
        routeName={routeNaming.CART}
      >
        <img src={iconCart} alt="" className={styles.image} />
        {
          CartStore.cart &&
          CartStore.cartTotalItems > 0 &&
          <div className={styles.badge}>
            {CartStore.cartTotalItems}
          </div>
        }
      </AppLink>
    </div>
    <CartPopUp
      className={styles.popUp}
    />
  </div>
);

CartButton.propTypes = IPropTypes;
CartButton.defaultProps = defaultProps;

const ObservedCartButton = observer(CartButton);

export { ObservedCartButton as CartButton };



// WEBPACK FOOTER //
// ./src/common/home-navbar/cart-button/CartButton.jsx